import { useEffect } from 'react';

/*
  react-data-table-component renders div cells that carry no column title, so
  the phone layout in responsive.scss ("each row becomes a card") has nothing
  to print next to a value. This hook copies every header's text onto the
  matching body cells as `data-label` and flags the table with `data-stack`,
  which is what the CSS keys on. Tables outside this opt-in keep scrolling.

  Crude is a separate project: its tables are never flagged.
*/

const CRUDE_PATH = /^\/crude(\/|$)/;

const textOf = el => (el.textContent || '').replace(/\s+/g, ' ').trim();

const setAttr = (el, name, value) => {
  if (el.getAttribute(name) !== value) el.setAttribute(name, value);
};

export const labelTable = table => {
  const labels = {};
  table.querySelectorAll('.rdt_TableCol[data-column-id]').forEach(col => {
    labels[col.getAttribute('data-column-id')] = textOf(col);
  });

  // No headers (e.g. custom noTableHead) means nothing to label with.
  if (Object.keys(labels).length === 0) return;

  table.querySelectorAll('.rdt_TableCell[data-column-id]').forEach(cell => {
    setAttr(
      cell,
      'data-label',
      labels[cell.getAttribute('data-column-id')] || ''
    );
  });
  setAttr(table, 'data-stack', '');
};

export const labelAllTables = (root = document) => {
  if (CRUDE_PATH.test(window.location.pathname)) return;
  root.querySelectorAll('.rdt_Table').forEach(labelTable);
};

const useStackedTables = () => {
  useEffect(() => {
    let frame = 0;
    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        labelAllTables();
      });
    };

    schedule();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
};

export default useStackedTables;
